import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { COOKIE_CONSENT_KEY, loadGoogleAnalytics } from "@/utils/googleAnalytics";

const STORAGE_KEY = COOKIE_CONSENT_KEY;

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored: string | null = null;
    try {
      stored = window.localStorage.getItem(STORAGE_KEY);
    } catch {
      stored = null;
    }
    if (!stored) {
      const timer = window.setTimeout(() => setVisible(true), 1200);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, []);

  const handleAccept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, "accepted");
    } catch {
      /* ignore storage errors */
    }
    loadGoogleAnalytics();
    setVisible(false);
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[60] transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
      role="dialog"
      aria-label="Aviso de cookies"
    >
      <div className="bg-background-50 border-t border-background-200/80">
        <div className="w-full px-4 md:px-6 py-2.5 md:py-3 flex flex-col md:flex-row items-center gap-2.5 md:gap-4 justify-between">
          <div className="flex items-center gap-2.5 text-center md:text-left">
            <i className="hidden md:inline ri-shield-check-line text-primary-600 text-base flex-shrink-0" />
            <p className="text-xs text-foreground-600 leading-snug">
              Usamos cookies para melhorar sua experiência, analisar o tráfego e personalizar
              anúncios. Saiba mais na nossa{" "}
              <Link
                to="/politica-de-privacidade"
                className="text-primary-600 hover:text-primary-700 underline cursor-pointer font-medium"
              >
                Política de Privacidade
              </Link>
              .
            </p>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              type="button"
              onClick={handleAccept}
              className="px-4 py-1.5 rounded-md bg-primary-500 text-white text-xs font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Aceitar todos
            </button>
            <Link
              to="/politica-de-privacidade"
              className="px-4 py-1.5 rounded-md border border-background-300/70 text-foreground-700 text-xs font-medium hover:bg-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Saiba mais
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}